export default __webpack_public_path__ + "assets/images/1.47fef1.png";